import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { addToSelected, resetDialog, openDialog } from '../modules/tableDialog'
import { setConfirmationItem } from '../modules/formDialog'
import {
  fetchGroupProfile,
  changeTabState,
  deleteGroupUsers,
  deleteGroupRoles,
  patchGroupUsers,
  patchGroupRoles } from '../modules/group'
import FormDialog from '../components/formDialog'
import {
  groupTableOptions,
  usersTableOptions,
  roleTableOptions } from '../constants/tableConfigs'
import Messages from '../constants/messages'
import { paginationChangePage, paginationChangeRowsPerPage } from '../modules/table'
import { resetForm, showDialog } from '../modules/formDialog'
import TableDialog from '../components/tableDialog'
import TabDisplay from '../components/tabDisplay'
import TableDisplay from '../components/tableDisplay'
import withStyles from 'material-ui/styles/withStyles'
import { getAdminTypeString, getUserName } from '../utils/helpers'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  changeTabState: PropTypes.func.isRequired,
  tabState: PropTypes.number.isRequired
}

const styles = theme => ({
  root: {
    maxWidth: 1000,
    margin: 'auto'
  },
  title: theme.title
})

export class Group extends Component {
  groupOptions = groupTableOptions.map((tableOption) => {
    if (tableOption.displayType === 'link') {
      return Object.assign(tableOption, {callback: (group) => this.props.changePage({pathname: `/groups/${group.id}`, state: group})})
    } else {
      return {...tableOption}
    }
  })

  tabOptions = [
    Messages['uiComponents']['TAB_USERS'],
    Messages['uiComponents']['TAB_ROLES']
  ]

  tableButtons = [
    {
      buttonName: 'Clear',
      callback: (item) => {
        this.props.setConfirmationItem(item)
        this.props.showDialog(true, 'clear')
      },
      tooltip: Messages['tooltips']['REMOVE']
    }
  ]

  dialogOptions = {
    new: [
      {
        type: 'userSelectField',
        name:'newUsers',
        friendlyName: Messages['uiComponents']['ADD_USER_TO_GROUP_SELECT_FIELD']
      }
    ],
    clear: [
      {
        type: 'confirmation',
        name:'name',
        friendlyName: Messages['uiComponents']['GROUP_REMOVE_USER_INPUT_FIELD'],
        confirmationType: 'removeFromGroup'
      }
    ]
  }

  componentDidMount() {
    const { fetchGroupProfile, groupProfile, groupList } = this.props
    const id = process.env.NODE_ENV === 'test' ? 1 : decodeURI(window.location.pathname).substring(decodeURI(window.location.pathname).lastIndexOf('/') + 1)
    if (groupProfile !== null && (!groupProfile.group || groupProfile.group.id !== id)) {
      if (groupList.length > 0) {
        fetchGroupProfile(id)
      }
    }
  }

  handleOnChange(index) {
    const { changeTabState } = this.props
    changeTabState(index)
  }

  handleRoleSubmit() {
    const {
      groupProfile,
      patchGroupRoles,
      resetDialog,
      roles,
      selected } = this.props

    if (selected.length > 0) {
      let newRoles = roles.filter(role => selected.some(id => id === role.id))
      patchGroupRoles(groupProfile.group.id, newRoles).then(() => resetDialog())
    } else {
      resetDialog()
    }
  }

  handleSubmit(formValues) {
    const {
      confirmationItem,
      deleteGroupUsers,
      deleteGroupRoles,
      formType,
      groupProfile,
      patchGroupUsers,
      resetForm,
      tabState,
      userList} = this.props

    const tab = ['users', 'roles'][tabState]
    switch(tab) {
      case 'users':
        if (formType === 'new') {
          const user = userList.filter(user => {
            return user.id === formValues.newUsers
          })
          formValues.id = formValues.group.id
          patchGroupUsers(formValues, user)
          resetForm()
          break
        } else {
          // TODO: Will not work until we get id back from the /api/v1/authz/groups/${groupId}/users route
          deleteGroupUsers(groupProfile.group.id, confirmationItem.id)
          resetForm()
          break
        }
      case 'roles':
        deleteGroupRoles(groupProfile.group.id, confirmationItem.id)
        resetForm()
        break
      default:
        break
    }
  }

  getProgressIndicatorText(formType, tabState) {
    if (formType === 'new') {
      if (tabState === 0) {
        return Messages['uiComponents']['ADDING_USER_MSG']
      }
      return Messages['uiComponents']['ADDING_ROLE_MSG']
    } else {
      return Messages['uiComponents']['REMOVING_MSG']
    }
  }

  setTitle(formType, tabState) {
    let tab = ['User', 'Role'][tabState]
    if (formType === 'new') {
      return Messages['uiComponents']['ADD_USER_TO_GROUP_TITLE']
    } else {
      return `${Messages['uiComponents']['REMOVE']} ${tab}`
    }
  }

  renderDialog() {
    const {
      addToSelected,
      formType,
      groupProfile,
      isLoadingDialog,
      openDialog,
      resetDialog,
      roles,
      selected,
      showTableDialog,
      tabState} = this.props

    let markup = null
    if (tabState === 1) {
      markup = (
        <TableDialog
          addToSelected={addToSelected}
          buttonLabel={Messages['uiComponents']['ADD_ROLE_TO_GROUP_BUTTON']}
          resetDialog={resetDialog}
          data={roles}
          userData={groupProfile.roles ? groupProfile.roles : []}
          handleSubmit={() => this.handleRoleSubmit()}
          infoText={this.getProgressIndicatorText(formType, tabState)}
          isLoading={isLoadingDialog}
          selected={selected}
          showDialog={showTableDialog}
          title={Messages['uiComponents']['ADD_ROLE_TO_GROUP_BUTTON']}
          openDialog={openDialog} />
      )
    }
    return markup
  }

  render() {
    const {
      classes,
      confirmationItem,
      currentContext,
      formType,
      groupProfile,
      isLoadingDialog,
      open,
      paginationChangePage,
      paginationChangeRowsPerPage,
      resetForm,
      rolePaginationPage,
      rolePaginationRowsPerPage,
      showDialog,
      tabState,
      userList,
      userMemberships,
      userPaginationPage,
      userPaginationRowsPerPage,
      userRoles } = this.props

    const adminType = getAdminTypeString(userMemberships, userRoles)

    return (
      <section className={classes.root}>
        <h3 className={classes.title}>{currentContext}</h3>
        { showDialog && <FormDialog
        buttonLabel={tabState === 0 ? Messages['uiComponents']['ADD_USER_TO_GROUP_TITLE'] : null} // null means no button
        data={{userList}}
        dialogOptions={this.dialogOptions[formType]}
        handleFormSubmit={(values) => this.handleSubmit(values)}
        infoText={this.getProgressIndicatorText(formType, tabState)}
        initialValues={groupProfile ? groupProfile : {users: []}} //Required for userList dropdown
        isLoading={isLoadingDialog}
        open={open}
        confirmationItem={confirmationItem}
        confirmationFieldData={{userName: getUserName(confirmationItem), groupName: (groupProfile && groupProfile.group && groupProfile.group.name) ? groupProfile.group.name : ''}}
        showDialog={showDialog}
        resetFormValues={resetForm}
        title={this.setTitle(formType, tabState)} />}
        { groupProfile && this.renderDialog() }
        { adminType === 'System-Admin' ?
            <TabDisplay
            onChange={(event, tabIndex) => this.handleOnChange(tabIndex)}
            tabState={tabState}
            tabOptions={this.tabOptions} /> : null}
        { tabState === 0 &&
          <section>
            <TableDisplay
              data={groupProfile && groupProfile.users ? groupProfile.users : []}
              page={userPaginationPage}
              paginationChangePage={paginationChangePage}
              paginationChangeRowsPerPage={paginationChangeRowsPerPage}
              rowsPerPage={userPaginationRowsPerPage}
              tab="user"
              tableOptions={usersTableOptions}
              tableButtons={this.tableButtons}
              totalCount={groupProfile && groupProfile.users ? groupProfile.users.length : 0}
              type="groupUsers" />
          </section>
        }
        { tabState === 1 &&
          <section>
            <TableDisplay
              data={groupProfile && groupProfile.roles ? groupProfile.roles : []}
              page={rolePaginationPage}
              paginationChangePage={paginationChangePage}
              paginationChangeRowsPerPage={paginationChangeRowsPerPage}
              rowsPerPage={rolePaginationRowsPerPage}
              tab="role"
              tableOptions={roleTableOptions}
              tableButtons={this.tableButtons}
              totalCount={groupProfile && groupProfile.roles ? groupProfile.roles.length : 0}
              type="groupRoles" />
          </section>
        }
      </section>
    )
  }
}
Group.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  currentContext: state.navigation.currentContext,
  tabState: state.group.tabState,
  formType: state.formDialog.formType,
  groupProfile: state.group.groupProfile,
  groupList: state.group.groups,
  confirmationItem: state.formDialog.confirmationItem,
  open: state.formDialog.open,
  isLoadingDialog: state.loading.isLoadingDialog,
  rolePaginationPage: state.table.paginationPage.groupRoles,
  rolePaginationRowsPerPage: state.table.paginationRowsPerPage.groupRoles,
  roles: state.role.roles,
  selected: state.tableDialog.selected,
  showTableDialog: state.tableDialog.showTableDialog,
  userList: state.user.users,
  userMemberships: state.authProfile.userMemberships,
  userPaginationPage: state.table.paginationPage.groupUsers,
  userPaginationRowsPerPage: state.table.paginationRowsPerPage.groupUsers,
  userRoles: state.authProfile.userRoles
})

const mapDispatchToProps = dispatch => bindActionCreators({
  addToSelected,
  changePage: (pushObj) => push(pushObj),
  changeTabState,
  deleteGroupUsers,
  deleteGroupRoles,
  fetchGroupProfile,
  openDialog,
  paginationChangePage,
  paginationChangeRowsPerPage,
  patchGroupUsers,
  patchGroupRoles,
  showDialog,
  setConfirmationItem,
  resetDialog,
  resetForm
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Group)
